import { useState } from 'react';
import { FaFacebookF, FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { HiOutlineLink } from 'react-icons/hi2';
import Reveal from '../../../shared/Reveal/Reveal';
import './Content.css';

const Content = ({ post }) => {
  const [copied, setCopied] = useState(false);

  const shareUrl =
    typeof window !== 'undefined' ? window.location.href : '';

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  const bodyParagraphs = (post.body || '')
    .split('\n\n')
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  return (
    <section className="market-analysis-content">
      <div className="market-analysis-content__inner">
        <Reveal>
          {post.lead ? <p className="market-analysis-content__lead">{post.lead}</p> : null}

          {post.lead ? <hr className="market-analysis-content__divider" /> : null}

          {bodyParagraphs.map((paragraph) => (
            <p key={paragraph} className="market-analysis-content__text">
              {paragraph}
            </p>
          ))}

          {post.image ? (
            <figure className="market-analysis-content__figure">
              <img
                className="market-analysis-content__image"
                src={post.image}
                alt=""
              />
            </figure>
          ) : null}

          <div className="market-analysis-content__footer">
            <div className="market-analysis-content__author">
              <img
                className="market-analysis-content__avatar"
                src={post.avatar}
                alt=""
                aria-hidden="true"
              />
              <div className="market-analysis-content__author-meta">
                <p className="market-analysis-content__author-name">{post.author}</p>
                <p className="market-analysis-content__author-date">{post.date}</p>
              </div>
            </div>
            <div className="market-analysis-content__share">
              <button
                type="button"
                className="market-analysis-content__share-btn market-analysis-content__share-btn--copy"
                onClick={handleCopyLink}
                aria-label={copied ? 'Link copied' : 'Copy link'}
              >
                <HiOutlineLink />
                {copied ? 'Copied' : 'Copy link'}
              </button>
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
                target="_blank"
                rel="noreferrer"
                className="market-analysis-content__share-btn"
                aria-label="Share on LinkedIn"
              >
                <FaLinkedinIn />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`}
                target="_blank"
                rel="noreferrer"
                className="market-analysis-content__share-btn"
                aria-label="Share on X"
              >
                <FaXTwitter />
              </a>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                target="_blank"
                rel="noreferrer"
                className="market-analysis-content__share-btn"
                aria-label="Share on Facebook"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Content;
